import type {IComboBoxOption} from "@fluentui/react";

export type ComboBoxOption = Omit<IComboBoxOption, "styles">;

export const setToComboBoxOption = <T>(arr: Set<T>): ComboBoxOption[] =>
  Array.from(arr).map((item: T) => {
    const combo: ComboBoxOption = {
      key: item as string,
      text: item as string,
    };

    return combo;
  });
